import {Injectable} from '@angular/core';

/**
 * Translations for basic statuses. (not really)
 */
@Injectable()
export class BasicStatusTranslationService {
  public i18nActive: any = $localize`:@@general.text.active:Active`;
  public i18nInactive: any = $localize`:@@general.text.inactive:Inactive`;
  public i18nSetupComplete: any = $localize`:@@general.text.setupComplete:Setup completed`;
  public i18nSetupIncomplete: any = $localize`:@@general.text.setupIncomplete:Not yet setup`;
  constructor() { }
}
